<div class="select-container">
  <div class="select" [class.disabled]="disabled" (click)="showDropdown()">
    @if (!selected) {
      <div>{{ placeholder }}</div>
    }
    @if (selected) {
      <div>
        {{ displayText }}
      </div>
    }
    <i class="material-icons">arrow_drop_down</i>
  </div>

  @if (showing) {
    <div class="dropdown-options-container">
      <div class="dropdown" (clickOutside)="hideDropdown()">
        <ng-content></ng-content>
      </div>
    </div>
  }
</div>
